import { render, staticRenderFns } from "./OrganizationMappingAddPcc.vue?vue&type=template&id=4271ab6c&scoped=true"
import script from "./OrganizationMappingAddPcc.vue?vue&type=script&lang=js"
export * from "./OrganizationMappingAddPcc.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMappingAddPcc.vue?vue&type=style&index=0&id=4271ab6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271ab6c",
  null
  
)

export default component.exports